import Blog from "../components/common-components/blog/Blog";
import Faqs from "../components/common-components/faqs/Faqs";
import Overview from "../components/common-components/overview/Overview";
import Testimonials from "../components/common-components/testimonials/Testimonials";
import SliderCategory from "../components/pages/home/components/SliderCategory";
import SliderThumb from "../components/common-components/sliderfull/SliderThumb";
import BenefitsContainer from "../components/pages/office/components/BenefitsContainer";
import IconBox from "../components/common-components/icon-box/IconBox";
import ContentContainer from "../components/pages/office/components/ContentContainer";
import CategorySlider from "../components/common-components/categoryslider/CategorySlider";

const constants = Object.freeze({
  CMS_TYPES: {
    SLIDER: "Slider",
    ABOUT_US: "AboutUs",
    FAQ: "Faq",
    IMAGE_GALLERY: "ImageGallery",
    OUR_SPACE: "OurSpace",
    PAGE_META: "PageMeta",
    PAGE_FOLD: "PageFold",
    OTHER_PAGE: "OtherPage",
    KNOW_MORE: "KnowMore",
    OFFER: "Offer",
    TESTIMONIAL: "Testimonial",
    HOME_PAGE: "HomePage",
    AVAILABILITY_PAGE: "AvailabilityPage",
    OFFER_PAGE: "OfferPage",
    SERVICE_TYPE: {
      MEETING_ROOM: "MeetingRoom",
      PRIVATE_OFFICE: "PrivateOffice",
      DEDICATED_DESK: "DedicatedDesk",
      FLEXI_DESK: "FlexiDesk",
    },
  },
  CMS_PAGES: {
    HOME: "Home",
    HOME_PAGE: "HomePage",
    AVAILABILITY_PAGE: "AvailabilityPage",
    OFFER_PAGE: "OfferPage",
    OFFICE_LIST: "OfficeList",
    SERVICE_PAGE: {
      MEETING_ROOM: "MeetingRoom",
      PRIVATE_OFFICE: "PrivateOffice",
      DEDICATED_DESK: "DedicatedDesk",
      FLEXI_DESK: "FlexiDesk",
    },
    ABOUT_US: "AboutUs",
    OUR_SPACE: "OurSpace",
    FAQ: "Faq",
    OFFER: "Offer",
  },
  HOMEPAGE_FOLDS: [
    {
      _id: "64b7dccd4864404b270e6f2c",
      Component: (props) => <Overview {...props} />,
    },
    {
      _id: "64b7dd954864404b270e6f3f",
      Component: (props) => <SliderThumb {...props} />,
    },
    {
      _id: "64b7de684864404b270e6f55",
      Component: (props) => <SliderCategory {...props} />,
    },
    {
      _id: "64b7dee84864404b270e6f72",
      Component: (props) => <Blog {...props} bgColorValue={"f9f9f9"} />,
    },
    {
      _id: "64ca15e04864404b270ed31f",
      Component: (props) => <Faqs {...props} />,
    },
    {
      _id: "64cc990ea8f4f0b9da329366",
      Component: (props) => <Testimonials {...props} bgColorValue={"f9f9f9"} />,
    },
  ],

  OFFICE_LIST_FOLDS: [
    {
      _id: "64e86bcb893f776a8eeede7b",
      Component: (props) => <Overview {...props} orientation={"right"} />,
    },
    {
      _id: "64e8734c893f776a8eeede93",
      Component: (props) => (
        <CategorySlider {...props} bgColorValue={"f9f9f9"} />
      ),
    },
    {
      _id: "64e87a2c893f776a8eeee27b",
      Component: (props) => <Blog {...props} />,
    },
    {
      _id: "64e87a57893f776a8eeee2b2",
      Component: (props) => <Testimonials {...props} />,
    },
    {
      _id: "64e87ab7893f776a8eeee2d1",
      Component: (props) => <Faqs {...props} />,
    },
  ],

  PRIVATE_OFFICE_FOLDS: [
    {
      _id: "64cf1306a8f4f0b9da32d6ae",
      Component: (props) => <Overview {...props} orientation={"right"} />,
    },
    {
      _id: "64cf1ca5a8f4f0b9da32dc14",
      Component: (props) => <Overview {...props} bgColorValue={"f9f9f9"} />,
    },

    {
      _id: "64cf1deda8f4f0b9da32dc40",
      Component: (props) => <BenefitsContainer {...props} />,
    },

    {
      _id: "64cf1e53a8f4f0b9da32dc5b",
      Component: (props) => (
        <ContentContainer {...props} bgColorValue={"f9f9f9"} />
      ),
    },

    {
      _id: "64cf1e8fa8f4f0b9da32dc6f",
      Component: (props) => <Overview {...props} />,
    },

    {
      _id: "64cf1f1fa8f4f0b9da32dc84",
      Component: (props) => <Blog {...props} />,
    },

    {
      _id: "64cf1fd0a8f4f0b9da32dd6d",
      Component: (props) => <Faqs {...props} />,
    },
  ],

  MEETING_ROOM_FOLDS: [
    {
      _id: "64d22b60a8f4f0b9da3317cd",
      Component: (props) => <Overview {...props} orientation={"right"} />,
    },
    {
      _id: "64d22bb2a8f4f0b9da3317fa",
      Component: (props) => <Overview {...props} bgColorValue={"f9f9f9"} />,
    },

    {
      _id: "64d22c1fa8f4f0b9da33180c",
      Component: (props) => <BenefitsContainer {...props} />,
    },

    {
      _id: "64d22c5ea8f4f0b9da331833",
      Component: (props) => (
        <ContentContainer {...props} bgColorValue={"f9f9f9"} />
      ),
    },

    {
      _id: "64d22c8fa8f4f0b9da331853",
      Component: (props) => <Overview {...props} />,
    },

    {
      _id: "64d22d16a8f4f0b9da331880",
      Component: (props) => <Blog {...props} />,
    },

    {
      _id: "64d22d4ba8f4f0b9da33189a",
      Component: (props) => <Faqs {...props} />,
    },
  ],

  DEDICATED_DESKS_FOLDS: [
    {
      _id: "64d22ff3a8f4f0b9da331d00",
      Component: (props) => <Overview {...props} orientation={"right"} />,
    },
    {
      _id: "64d2301fa8f4f0b9da331d1d",
      Component: (props) => <Overview {...props} bgColorValue={"f9f9f9"} />,
    },

    {
      _id: "64d2308ea8f4f0b9da331d3b",
      Component: (props) => <BenefitsContainer {...props} />,
    },

    {
      _id: "64d230c6a8f4f0b9da331d83",
      Component: (props) => (
        <ContentContainer {...props} bgColorValue={"f9f9f9"} />
      ),
    },

    {
      _id: "64d230eda8f4f0b9da331d97",
      Component: (props) => <Overview {...props} />,
    },

    {
      _id: "64d23131a8f4f0b9da331db8",
      Component: (props) => <Blog {...props} />,
    },

    {
      _id: "64d2316aa8f4f0b9da331dde",
      Component: (props) => <Faqs {...props} />,
    },
  ],

  FLEXI_DESKS_FOLDS: [
    {
      _id: "64cf1306a8f4f0b9da32d6ae",
      Component: (props) => <Overview {...props} orientation={"right"} />,
    },
    {
      _id: "64cf1ca5a8f4f0b9da32dc14",
      Component: (props) => <Overview {...props} bgColorValue={"f9f9f9"} />,
    },

    // {
    //   _id: "64cf1deda8f4f0b9da32dc40",
    //   Component: (props) => <BenefitsContainer {...props} />,
    // },

    // {
    //   _id: "64cf1e53a8f4f0b9da32dc5b",
    //   Component: (props) => <ContentContainer {...props} bgColorValue = {"f9f9f9"}/>,
    // },

    // {
    //   _id: "64cf1e8fa8f4f0b9da32dc6f",
    //   Component: (props) => <Overview {...props} />,
    // },

    // {
    //   _id: "64cf1f1fa8f4f0b9da32dc84",
    //   Component: (props) => <Blog {...props} />,
    // },

    // {
    //   _id: "64cf1fd0a8f4f0b9da32dd6d",
    //   Component: (props) => <Faqs {...props} />,
    // },
  ],

  AVAILABILITY_PAGE_FOLD: [
    {
      _id: "64d5d7a7a8f4f0b9da334be1",
      Component: (props) => <Overview {...props} bgColorValue={"f9f9f9"}  />,
    },

    {
      _id: "66278d9a8aa631532b654c6d",
      Component: (props) => <Overview {...props} orientation={"right"} />,
    },

    {
      _id: "66278ec68aa631532b654ce4",
      Component: (props) => <Overview {...props} bgColorValue={"f9f9f9"}  />,
    },

    {
      _id: "66278e868aa631532b654cc3",
      Component: (props) => <IconBox {...props} />,
    },
    {
      _id: "64e44043893f776a8eee86ca",
      Component: (props) => <Faqs {...props}  bgColorValue={"f9f9f9"} />,
    },
  ],

  OFFER_PAGE_FOLD: [
    {
      _id: "64e57046893f776a8eeea15f",
      Component: (props) => <Overview {...props} bgColorValue={"f9f9f9"} />,
    },
    {
      _id: "64e570cb893f776a8eeea170",
      Component: (props) => <Faqs {...props} />,
    },
  ],

  ABOUT_US_FOLDS: [
    {
      _id: "629f48a55d63730594cd498d",
      Component: (props) => <Overview {...props} />,
    },
    {
      _id: "629f48c05d63730594cd4992",
      Component: (props) => <SliderThumb {...props} />,
    },
    {
      _id: "629f48da5d63730594cd4997",
      Component: (props) => <Overview {...props} orientation={"right"} />,
    },
  ],

  FALLBACK_IMG:
    "data:image/png;base64,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",
});

export default constants;